module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: {
      active: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    staticClass: "auto",
    on: {
      "click": _vm.toggle
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Veículo")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-sub dk"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'policiacivil.veiculo.avaria.list'
      }
    }
  }, [_c('span', [_vm._v("Avarias")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'config.estado-veiculo.list'
      }
    }
  }, [_c('span', [_vm._v("Estados de Veículo")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "pull-right text-muted"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-angle-right text"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-fw fa-angle-down text-active"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-sub-header"
  }, [_c('a', [_c('span', {
    staticClass: "text-muted teste"
  }, [_vm._v("Polícia Civil")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c36828ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/menu/policiacivil/configuracoes/Veiculo.vue
// module id = 1857
// module chunks = 17